import {ancestorAxis, wikiTab, jobTab} from 'uix/views/utils'

let TranscriptionWikipage = ident => ({
  parts: [
    {
      type: 'TranscriptionWikipage',
      ident: `transcription/${ident}`,
    },
  ],
})

export const xtranscript = {
  cfg: ({dconfig}) => dconfig.transcription.on,
  layout: 'blank',
  tabs: {
    home: {
      default: true,
      ...TranscriptionWikipage('home'),
    },
    specs: TranscriptionWikipage('specs'),
    terms: TranscriptionWikipage('terms'),
    guidelines: TranscriptionWikipage('guidelines'),
    trguidelines: TranscriptionWikipage('trguidelines'),
    // account managment
    resetpw: {parts: []},
    account: {acl: 'g:transcribe,g:transcribeRelease', parts: ['TranscriptionAccount']},
    // registration
    login: {parts: []},
    validatetoken: {parts: []},
    // editor
    wiki: {
      acl: 'g:transcribeRelease,g:transcribe,g:wiki',
      parts: [{type: 'FulltextView', autoEdit: true, transcriptionMode: true}],
      filters: [ancestorAxis],
    },
    editor_frame: {
      layout: 'L131Split',
      acl: 'g:transcribeRelease,g:transcribe,g:wiki',
      noReloginDialog: true, // is run in iframe
      filters: [ancestorAxis],
      parts: [
        {
          type: 'FulltextView',
          bare: true,
          autoEdit: true,
          transcriptionMode: true,
        },
      ],
    },
    // operator's users-survey
    users: {acl: 'g:transcribeRelease', parts: ['TranscriptionUsers']},
    // user's activity-survey
    activity: {acl: 'g:transcribe', parts: ['TranscriptionActivity']},
    // operator's list for reviewing transcriptions
    review: {
      acl: 'g:transcribeRelease',
      cfg: ({dconfig}) => dconfig.wiki.checkpoints.serveReleased,
      parts: ['TranscriptionReview'],
    },
    published: {acl: 'g:transcribe', parts: ['TranscriptionPublished']},
    begun: {acl: 'g:transcribeRelease', parts: ['TranscriptionBegun']},
  },
}
